// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PauseLoadIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PauseLoadIcon" ref={forwardedRef} {...props}>
      <path d="M10.001 16.5a6.5 6.5 0 0 1-6.467-5.84l-1.452.482A8.002 8.002 0 0 0 18.002 10a7.99 7.99 0 0 0-3-6.245 7.97 7.97 0 0 0-5-1.755 7.97 7.97 0 0 0-5.464 2.156l.907 1.208A6.48 6.48 0 0 1 10.001 3.5a6.47 6.47 0 0 1 4.062 1.425A6.49 6.49 0 0 1 16.501 10a6.49 6.49 0 0 1-2.438 5.075 6.47 6.47 0 0 1-4.062 1.425" />
      <path d="M7.75 7v6h1.5V7z" />
      <path d="M10.75 13V7h1.5v6z" />
      <path d="M3.25 9a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PauseLoadIcon = /* @__PURE__ */ Object.assign(
  PauseLoadIconComponent,
  { displayName: 'PauseLoadIcon' },
);
